import { createAction } from '@reduxjs/toolkit';

export const getScheduleShift = createAction('[ScheduleShift] getScheduleShift');
export const getScheduleShiftSuccess = createAction('[ScheduleShift] getScheduleShiftSuccess');
export const getScheduleShiftFailure = createAction('[ScheduleShift] getScheduleShiftFailure');
